// Level up notification component
import { getProficiencyBonus, getXpForNextLevel, getXpProgress } from '../../types';
import './LevelUpNotification.css';

interface LevelUpNotificationProps {
  previousLevel: number;
  currentLevel: number;
  onDismiss: () => void;
}

export function LevelUpNotification({ previousLevel, currentLevel, onDismiss }: LevelUpNotificationProps) {
  const levelsGained = currentLevel - previousLevel;
  const prevProfBonus = getProficiencyBonus(previousLevel);
  const newProfBonus = getProficiencyBonus(currentLevel);
  const xpForNext = getXpForNextLevel(currentLevel);
  const xpProgress = getXpProgress(currentLevel);

  return (
    <div className="level-up-notification fade-in" onClick={onDismiss}>
      <div className="level-up-content">
        <div className="level-up-header">
          <span className="level-up-icon">⬆️</span>
          <h3>LEVEL UP!</h3>
        </div>
        
        <div className="level-up-details">
          <div className="level-up-row">
            <span className="level-up-label">Level</span>
            <span className="level-up-value">
              <span className="level-old">{previousLevel}</span>
              <span className="level-arrow">→</span>
              <span className="level-new">{currentLevel}</span>
            </span>
          </div>
          
          {levelsGained > 1 && (
            <div className="level-up-row">
              <span className="level-up-label">Levels Gained</span>
              <span className="level-up-value levels-gained">+{levelsGained}</span>
            </div>
          )}
          
          <div className="level-up-row">
            <span className="level-up-label">HP</span>
            <span className="level-up-value hp-gain">+{levelsGained * 6}</span>
            <span className="level-up-subtext">(approx.)</span>
          </div>
          
          <div className="level-up-row">
            <span className="level-up-label">Proficiency</span>
            <span className="level-up-value">
              <span className="level-old">+{prevProfBonus}</span>
              <span className="level-arrow">→</span>
              <span className="level-new">+{newProfBonus}</span>
            </span>
          </div>
          
          <div className="level-up-row">
            <span className="level-up-label">XP to Next</span>
            <span className="level-up-value xp-progress">
              {xpProgress.current} / {xpForNext}
            </span>
          </div>
        </div>
        
        <button className="level-up-dismiss" onClick={onDismiss}>
          Continue
        </button>
      </div>
    </div>
  );
}
